module.exports = __webpack_public_path__ + "img/img-course-thumb-default.6f8c8412.png";